// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Tooltip } from '@plesk/ui-library';

export interface ITruncateTextProps extends React.HTMLProps<HTMLSpanElement> {
    text: string;
    maxLength: number;
    ellipsis?: string;
    withTooltip?: boolean;
}

export const TruncateText: React.FC<ITruncateTextProps> = ({
    text,
    maxLength,
    ellipsis = '...',
    withTooltip = true,
    ...spanProps
}) => {
    const isTruncated = text.length > maxLength;
    const displayed = isTruncated ? `${text.slice(0, maxLength)}${ellipsis}` : text;

    const content = <span {...spanProps}>{displayed}</span>;

    return isTruncated && withTooltip
        ? <Tooltip title={text}>{content}</Tooltip>
        : content;
};